<template>
  <div>
    <!-- 紧凑模式：batchPayFeeOrderList 中一行显示 -->
    <div v-if="compact && accountList.length > 0" class="account-compact">
      <span class="compact-label">{{ $t('payFeeUserAccount.accountInfo') }}:</span>
      <template v-for="acct in accountList">
        <el-radio
          :key="acct.acctId"
          v-model="selectedAccount"
          :label="acct.acctId"
          border
          size="mini"
          class="compact-radio"
          @change="() => handleAccountChange(acct)"
        >{{ acct.acctTypeName }}-{{ acct.acctName }} {{ acct.amount }}{{ $t('payFeeUserAccount.yuan') }}</el-radio>
      </template>
      <el-button type="text" size="mini" icon="el-icon-refresh" @click="queryPayFeeUserAccount">
        {{ $t('payFeeUserAccount.refresh') }}
      </el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus"
        @click="openAddUserAmountModal(accountList[0])">
        {{ $t('payFeeUserAccount.prestore') }}
      </el-button>
    </div>

    <!-- 默认模式：完整卡片表格 -->
    <el-card v-else-if="!compact && accountList.length > 0" class="margin-bottom-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('payFeeUserAccount.accountInfo') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="queryPayFeeUserAccount">
          <i class="el-icon-refresh"></i>
          {{ $t('payFeeUserAccount.refresh') }}
        </el-button>
      </div>

      <el-table :data="accountList" border style="width: 100%" size="mini">
        <el-table-column align="center" :label="$t('payFeeUserAccount.select')" width="80">
          <template slot-scope="scope">
            <el-radio
              v-model="selectedAccount"
              :label="scope.row.acctId"
              @change="() => handleAccountChange(scope.row)"
            >
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="acctTypeName" align="center" :label="$t('payFeeUserAccount.accountType')" />
        <el-table-column prop="acctName" align="center" :label="$t('payFeeUserAccount.accountName')" />
        <el-table-column prop="amount" align="center" :label="$t('payFeeUserAccount.accountAmount')">
          <template slot-scope="scope">
            {{ scope.row.amount }} {{ $t('payFeeUserAccount.yuan') }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('payFeeUserAccount.operation')" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openAddUserAmountModal(scope.row)">
              <i class="el-icon-plus"></i>
              {{ $t('payFeeUserAccount.prestore') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryCommunityOwnerAccount } from '@/api/fee/payFeeOrderApi'

export default {
  name: 'PayFeeUserAccount',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      accountList: [],
      feeId: '',
      ownerId: '',
      roomId: '',
      communityId: '',
      selectedAccount: '' // 单选账户
    }
  },
  methods: {
    open(params) {
      this.feeId = params.feeId
      this.ownerId = params.ownerId || ''
      this.roomId = params.roomId || ''
      this.listUserAccount()
    },
    close() {
      this.dialogVisible = false
    },
    async listUserAccount() {
      try {
        this.communityId = await getCommunityId()
        const params = {
          page: 1,
          row: 20,
          feeId: this.feeId,
          ownerId: this.ownerId,
          roomId: this.roomId,
          communityId: this.communityId
        }

        const response = await queryCommunityOwnerAccount(params)
        this.accountList = response.data || []
      } catch (error) {
        console.error('查询用户账户失败:', error)
      }
    },
    queryPayFeeUserAccount() {
      this.listUserAccount()
    },
    openAddUserAmountModal(userAccount) {
      window.open(`/#/views/owner/ownerDetail?ownerId=${userAccount.objId}&currentTab=ownerDetailAccount`)
    },
    // 处理账户选择变化
    handleAccountChange(account) {
      if (!account) {
        this.selectedAccount = ''
      } else {
        this.selectedAccount = account.acctId
      }
      this.computeFeeUserAmount()
    },
    // 计算费用使用金额
    computeFeeUserAmount() {
      let totalUserAmount = 0.0
      let selectAccount = []

      const account = this.accountList.find(item => item.acctId === this.selectedAccount)
      if (account && Number(account.amount) !== 0) {
        totalUserAmount = parseFloat(account.amount)
        selectAccount = [account]
      }

      this.$emit('changeUserAmountPrice', {
        totalUserAmount,
        accountList: this.accountList,
        integralAmount: 0,
        cashAmount: totalUserAmount,
        couponAmount: 0,
        selectAccount
      })
    },
    handleClose() {
      this.accountList = []
      this.selectedAccount = '' // 清空选中的账户
      this.feeId = ''
      this.ownerId = ''
      this.roomId = ''
    }
  }
}
</script>

<style scoped>
.compact-label {
  font-weight: bold;
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
}

.compact-radio {
  margin-right: 6px;
}

.account-compact {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
</style>